import React from "react";
import PropTypes from "prop-types";

import DataQualityResults from "./DataQualityResults";
import { Paginator } from "./lib/paginator/Paginator";

import { backboneConnect } from "lib/common/hoc/BackboneReact/backboneConnect";
import useFluxStore from "@armus/use-flux-store";
import userStore from "data/userStore";

export function DataQualityResultsLayout({
                                             stereotype,
                                             searchResults,
                                             page,
                                             pageSize,
                                             sorts,
                                             getReportTypeKey,
                                             onRecordSelection,
                                             onSort,
                                             paginatorSearch,
                                         }) {
    const [isAggregate, canUseDE] = useFluxStore(
        () => [
            userStore.isAggregate(),
            userStore.canUseDE(),
        ],
        [userStore],
    );

    const collection = searchResults.get("results");
    let fields = stereotype.get("fields");
    if (isAggregate) {
        fields = new Backbone.Collection(fields.models);
        fields.add({
            key: "ao_owner_name",
            name: "Data Owner",
            type: "string",
        }, {at: 0});
    }

    const pageCount = searchResults.get("pageCount");
    const results = searchResults.get("results");

    return (
        <React.Fragment>
            <div className="header">
                <div className="title">
                    <h1>Report Results</h1>
                </div>
            </div>
            <div className="results">
                <DataQualityResults fields={fields}
                                    collection={collection || new Backbone.Collection()}
                                    hasStereotype
                                    reportTypeKey={getReportTypeKey()}
                                    onRecordSelection={canUseDE ? onRecordSelection : null}
                                    onSort={onSort}
                                    sorts={sorts}
                />
            </div>
            <div className="footer">
                <Paginator search={paginatorSearch}
                           page={page}
                           results={results}
                           pageSize={pageSize}
                           pageCount={pageCount} />
            </div>
        </React.Fragment>
    );
}

DataQualityResultsLayout.propTypes = {
    stereotype: PropTypes.object.isRequired,
    searchResults: PropTypes.object.isRequired,
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pageCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    results: PropTypes.object,
    getReportTypeKey: PropTypes.func.isRequired,
    onRecordSelection: PropTypes.func,
    onSort: PropTypes.func.isRequired,
    sorts: PropTypes.instanceOf(Backbone.Model),
    paginatorSearch: PropTypes.func.isRequired
};

const config = (props) => ({
    stereotype: {
        listenOn: "model"
    },
    searchResults: {
        listenOn: "model"
    },
    page: {
        listenOn: "model"
    },
    pageSize: {
        listenOn: "model"
    },
    sorts: {
        listenOn: "model"
    },
    getReportTypeKey: () => props.model.getReportTypeKey(),
    onRecordSelection: (record) => props.view.dispatch("load:dataQualityDetails", record),
    onSort: () => {
        props.model.resetPagination();
        props.view.dispatch("search:dataQualityReport", props.model);
    },
    paginatorSearch: (page, pageSize) => {
        const model = props.model;
        if (parseInt(pageSize)) {
            model.set("pageSize", pageSize);
        }
        if (model.hasChanged("pageSize")) {
            model.resetPagination();
        } else {
            if (parseInt(page)) {
                model.set("page", page);
            }
        }
        props.view.dispatch("search:dataQualityReport", model);
    }
});

export const BackboneDataQualityResultsLayout = backboneConnect(config)(DataQualityResultsLayout);



// WEBPACK FOOTER //
// ./app/lib/dqr/views/results/DataQualityResultsLayout.js